module.exports = __webpack_public_path__ + "../resources/images/illustration_folder-d1f052466c8c55af852b62c97980d089.svg";